import axios from "axios";

const api = axios.create({
  baseURL: "https://cakewalk.mwv.one",
});

export default api;
